import { Grid } from '@mui/material';
import { PqrTypeDataProps } from './props';
import { usePqrTypeData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrTypeData = (props: PqrTypeDataProps) => {
    const { formik } = usePqrTypeData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extra}
                    errors={formik.errors.extra}
                    value={formik.values.extra}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
        </Grid>
    );
};
